import { Box } from "@mui/material";
import { ExternalLink } from "../ExternalLink";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Party.Form.LegalEntity
    .RegistryLinks;

type Props = {
  companyNumber: string;
};

export const RegistryLinks = ({ companyNumber }: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" justifyContent="space-between">
      <ExternalLink
        text={t(COMPONENT_RESOURCES.Or)}
        url={`https://or.justice.cz/ias/ui/rejstrik-$firma?ico=${companyNumber}`}
      />
      <ExternalLink
        text={t(COMPONENT_RESOURCES.Isir)}
        url={`https://isir.justice.cz/isir/ueu/vysledek_lustrace.do?ceuprob=x&aktualnost=AKTUALNI_I_UKONCENA&ic=${companyNumber}`}
      />
      <ExternalLink
        text={t(COMPONENT_RESOURCES.Esm)}
        url={`https://esm.justice.cz/ias/issm/rejstrik-$sm?jenPlatne=PLATNE&ico=${companyNumber}`}
      />
    </Box>
  );
};
